<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  Udregning
  @if (moms) {
    inkl. moms
  }
  @if (!moms) {
    ekskl. moms
  }
</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<div mat-dialog-content>
  <table class="table margin--top-m">
    <tbody>
      @for (p of priceComponents; track p) {
        <tr>
          <td>{{ p.description }}</td>
          <td class="align-right">
            @if (moms) {
              <span>{{ p.price.withMoms | dkCurrency }}</span>
            }
            @if (!moms) {
              <span>{{ p.price.withoutMoms | dkCurrency }}</span>
            }
          </td>
        </tr>
      }
      @if (opkraevning.rabat.isApplicable) {
        <tr>
          <td>
            @if (opkraevning.rabat?.kontant) {
              <span>Rabat, kontant</span>
            }
            @if (opkraevning.rabat?.procent) {
              <span>Rabat, {{ opkraevning.rabat.procent }}%</span>
            }
            <span>&nbsp;({{ opkraevning.rabat.tekst }})</span>
          </td>
          <td class="align-right">
            @if (opkraevning.rabat?.kontant) {
              @if (moms) {
                <span>{{ opkraevning.rabat.kontant.withMoms * -1 | dkCurrency }}</span>
              }
              @if (!moms) {
                <span>{{ opkraevning.rabat.kontant.withoutMoms * -1 | dkCurrency }}</span>
              }
            }
            @if (opkraevning.rabat?.procent) {
              @if (moms) {
                <span>{{ listPrice.withMoms * (opkraevning.rabat.procent / 100) * -1 | dkCurrency }}</span>
              }
              @if (!moms) {
                <span>{{ listPrice.withoutMoms * (opkraevning.rabat.procent / 100) * -1 | dkCurrency }}</span>
              }
            }
          </td>
        </tr>
      }
      <tr>
        <td class="bold">Total</td>
        <td class="bold align-right">
          @if (moms) {
            <span>{{ totalPrice.withMoms | dkCurrency }}</span>
          }
          @if (!moms) {
            <span>{{ totalPrice.withoutMoms | dkCurrency }}</span>
          }
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div mat-dialog-actions class="row-reverse">
  <button mat-raised-button color="primary" mat-dialog-close>Luk</button>
</div>
